/**
 * Envia contatos do site para o Discord.
 *
 * Dois formulários usam este envio:
 *  - a roda "Começar um projeto" da Home (source: 'wheel')
 *  - o formulário da página de Contato (source: 'contact')
 *
 * Destino, em ordem de preferência:
 *  1. REACT_APP_LEAD_ENDPOINT: um proxy seu (função serverless) que recebe
 *     { lead } e repassa ao Discord. Recomendado: a URL do webhook fica no servidor.
 *  2. REACT_APP_DISCORD_WEBHOOK_URL: o webhook direto. Funciona, mas a URL
 *     vai embutida no JavaScript público do site.
 *
 * As variáveis entram no build (CRA). Configure em .env.local (fora do git).
 */

const LIMIT = 1000; // campos de embed do Discord aceitam até 1024 caracteres

const clip = (v) => {
  const s = Array.isArray(v) ? v.join(', ') : String(v ?? '').trim();
  if (!s) return '-';
  return s.length > LIMIT ? `${s.slice(0, LIMIT - 1)}…` : s;
};

const field = (name, value, inline = true) => ({ name, value: clip(value), inline });

function fieldsFor(lead) {
  if (lead.source === 'contact') {
    return [
      field('Nome', lead.name),
      field('Celular', lead.phone),
      field('E-mail', lead.email),
      field('Assunto', lead.message, false),
    ];
  }
  return [
    field('Nome', lead.name),
    field('WhatsApp', lead.phone),
    field('E-mail', lead.email),
    field('Empresa', lead.company),
    field('O que quer construir', lead.type),
    field('Fase da ideia', lead.phase),
    field('Funcionalidades', lead.features, false),
    field('Prazo', lead.deadline),
    field('Investimento', lead.budget),
    field('Ideia', lead.idea, false),
  ];
}

export function buildDiscordPayload(lead) {
  return {
    username: 'Idealizer | Site',
    // Nada digitado pelo visitante pode mencionar @everyone, cargos ou pessoas.
    allowed_mentions: { parse: [] },
    embeds: [
      {
        title: lead.source === 'contact' ? 'Nova mensagem pelo contato' : 'Novo projeto pelo site',
        color: 0x22c55e,
        fields: fieldsFor(lead),
        footer: { text: `Página: ${lead.page || '/'}` },
        timestamp: new Date().toISOString(),
      },
    ],
  };
}

export async function sendLead(lead) {
  const proxy = process.env.REACT_APP_LEAD_ENDPOINT;
  const webhook = process.env.REACT_APP_DISCORD_WEBHOOK_URL;

  if (!proxy && !webhook) {
    throw new Error('Envio não configurado: defina REACT_APP_DISCORD_WEBHOOK_URL ou REACT_APP_LEAD_ENDPOINT.');
  }

  const res = proxy
    ? await fetch(proxy, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lead }),
      })
    : await fetch(webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildDiscordPayload(lead)),
      });

  if (!res.ok) throw new Error(`Discord respondeu ${res.status}`);
  return true;
}
